/* eslint-disable @cspell/spellchecker */
import { useEffect, useRef } from 'react'
import { app, env } from 'config'

const useConvert = () => {
  const snippetAppended = useRef<boolean>(false)

  useEffect(() => {
    if (!app.analyticsEnabled) {
      return
    }

    if (snippetAppended.current) {
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = env.REACT_APP_CONVERT_URL
    document.head.appendChild(script)
    snippetAppended.current = true
  }, [])
}

export default useConvert
